import React, { useState, useEffect, useRef } from 'react';
import { Head } from '@inertiajs/react';
import FloatingMenu from '../../Components/FloatingMenu';
import MenuOverlay from '../../Components/MenuOverlay';
import AboutUs from '../../Components/AboutUs';
import Footer from '../../Components/Footer';
import SmoothScroll from '../../Components/SmoothScroll';

const About = () => {
    const scrollContainerRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const wrapper = scrollContainerRef.current;
        if (!wrapper) return;

        const handleScroll = (e) => {
            if (e.target.scrollTop > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        wrapper.addEventListener('scroll', handleScroll);
        return () => wrapper.removeEventListener('scroll', handleScroll);
    }, []);

    const isBrandBoxVisible = !isScrolled || isMenuOpen;

    return (
        <SmoothScroll ref={scrollContainerRef}>
            <Head>
                <title>About Us - Hollywood Royale Garden Assisted Living</title>
                <meta name="description" content="Learn more about Hollywood Royale Garden, our mission, values, and our commitment to providing exceptional assisted living care in Hollywood." />
                <meta property="og:title" content="About Us - Hollywood Royale Garden" />
                <meta property="og:description" content="Our story and commitment to senior care excellence in the heart of Hollywood." />
                <meta property="og:image" content="/hrlogo2.png" />
            </Head>

            <FloatingMenu
                isVisible={true}
                isScrolled={isScrolled}
                toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                isMenuOpen={isMenuOpen}
            />

            <MenuOverlay isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

            <div className={`brand-box2 ${isBrandBoxVisible ? 'visible' : 'hidden'}`} onClick={() => window.location.href = '/'}>
                <img src="/hrlogo2.png" alt="Hollywood Royale" className="brand-image" />
            </div>

            <div style={{ height: '100px' }}></div>

            <main>
                <AboutUs />
            </main>

            <Footer />
        </SmoothScroll>
    );
};

export default About;
